import styled from 'styled-components';

const WrapperStyled = styled.div`
  background: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 28px 24px;
  border: 1px #c9cfd7 solid;
  border-radius: 8px;
  width: 100%;
`;
export default WrapperStyled;
